"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PpaLabel = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _common = require("../../common");
var _isPpaLabel = require("./isPpaLabel");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PpaLabel = ({
  label,
  type,
  className,
  productCode,
  shouldRenderEmptyLabel,
  size = 'medium',
  maxLines = 0
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isEmpty = (0, _react.useMemo)(() => !(0, _isPpaLabel.isPpaLabel)(type) || !label, [label, type]);
  if (isEmpty && !shouldRenderEmptyLabel) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    className: className,
    isEmpty: isEmpty,
    size: size,
    "data-testid": `${getTestId(_common.PPA_LABEL)}-${productCode}`,
    children: !(0, _isPpaLabel.isPpaLabel)(type) && shouldRenderEmptyLabel ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Text, {
      maxLines: maxLines,
      size: size,
      children: label
    })
  });
};
exports.PpaLabel = PpaLabel;
